var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"gizmos",style:(_vm.styles)},_vm._l((_vm.webjets),function(w){return _c('Gizmo',{attrs:{"webjet":w}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }